import { Plus, X } from 'lucide-react'
import './editors.css'

const EMPTY_EXPR = { column_name: '', expression: '' }

function parseValue(raw) {
  if (!raw) return []
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function ExpressionListEditor({ value, onChange, disabled }) {
  const expressions = parseValue(value)

  const emit = (next) => onChange(JSON.stringify(next))

  const updateExpression = (idx, key, val) => {
    const updated = [...expressions]
    updated[idx] = { ...updated[idx], [key]: val }
    emit(updated)
  }

  const addExpression = () => {
    emit([...expressions, { ...EMPTY_EXPR }])
  }

  const removeExpression = (idx) => {
    emit(expressions.filter((_, i) => i !== idx))
  }

  return (
    <div>
      {expressions.map((expr, idx) => (
        <div key={idx} className="editor-row">
          <input
            className="editor-input"
            value={expr.column_name || ''}
            onChange={(e) => updateExpression(idx, 'column_name', e.target.value)}
            placeholder="Output column"
            disabled={disabled}
          />
          <input
            className="editor-input editor-input-wide"
            value={expr.expression || ''}
            onChange={(e) => updateExpression(idx, 'expression', e.target.value)}
            placeholder="SQL expression"
            disabled={disabled}
          />
          <button
            className="editor-remove-btn"
            onClick={() => removeExpression(idx)}
            disabled={disabled}
            title="Remove expression"
          >
            <X size={12} />
          </button>
        </div>
      ))}

      {expressions.length === 0 && (
        <div className="editor-empty">No expressions defined</div>
      )}

      <button
        className="editor-add-btn"
        onClick={addExpression}
        disabled={disabled}
      >
        <Plus size={12} />
        Add Expression
      </button>
    </div>
  )
}

export default ExpressionListEditor
